import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading skeleton for the pipeline page
 * Displays placeholder UI while data is loading
 */
export function PipelineLoadingSkeleton() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
      <div className="container mx-auto px-6 py-12 space-y-8">
        <div className="space-y-2">
          <Skeleton className="h-8 w-56" />
          <Skeleton className="h-4 w-80" />
        </div>
        <div className="flex flex-wrap gap-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={`filter-${index}`} className="h-10 w-32 rounded-full" />
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={`stage-${index}`} className="space-y-3">
              <Skeleton className="h-6 w-40" />
              <Skeleton className="h-64 rounded-3xl" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
